'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "start", "end"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useElementPositionInCollection, useEvent } from '@mui/x-scheduler-headless/internals';
import { useRenderElement } from '@mui/x-scheduler-headless/base-ui-copy';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { TimelineGridEventPlaceholderCssVars } from "./TimelineGridEventPlaceholderCssVars.mjs";
import { eventTimelinePremiumViewSelectors } from "../../event-timeline-premium-selectors/index.mjs";
import { TimelineGridEventPlaceholderDataAttributes } from "./TimelineGridEventPlaceholderDataAttributes.mjs";
const overflowStateAttributesMapping = {
  startingBeforeEdge: value => value ? {
    [TimelineGridEventPlaceholderDataAttributes.startingBeforeEdge]: ''
  } : null,
  endingAfterEdge: value => value ? {
    [TimelineGridEventPlaceholderDataAttributes.endingAfterEdge]: ''
  } : null
};
export const TimelineGridEventPlaceholder = /*#__PURE__*/React.forwardRef(function TimelineGridEventPlaceholder(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      start,
      end
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const store = useEventTimelinePremiumStoreContext();

  // Selector hooks
  const viewConfig = useStore(store, eventTimelinePremiumViewSelectors.config);

  // Feature hooks
  const {
    position,
    duration,
    startingBeforeEdge,
    endingAfterEdge
  } = useElementPositionInCollection({
    start,
    end,
    collectionStart: viewConfig.start,
    collectionEnd: viewConfig.end
  });

  // Rendering hooks
  const style = React.useMemo(() => ({
    [TimelineGridEventPlaceholderCssVars.xPosition]: `${position * 100}%`,
    [TimelineGridEventPlaceholderCssVars.width]: `${duration * 100}%`
  }), [position, duration]);
  const props = React.useMemo(() => ({
    style
  }), [style]);
  const {
    state: eventState
  } = useEvent({
    start,
    end
  });
  const state = _extends({}, eventState, {
    startingBeforeEdge,
    endingAfterEdge
  });
  return useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef],
    props: [props, elementProps],
    stateAttributesMapping: overflowStateAttributesMapping
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridEventPlaceholder.displayName = "TimelineGridEventPlaceholder";